<div [formGroup]="studentFormGroup" style="padding-top: 10px;">
    <mat-form-field [hidden]="true">
        <input matInput formControlName="isAddStudentByLsuId">
    </mat-form-field>
    <mat-form-field [hidden]="true">
        <input matInput formControlName="studentId">
    </mat-form-field>
    <mat-form-field [hidden]="true">
        <input matInput formControlName="personId">
    </mat-form-field>
    <mat-form-field [hidden]="true">
        <input matInput formControlName="tenantId">
    </mat-form-field>
    <div align="end" *ngIf="selectedStudent && WriteAction" >
        <button  mat-raised-button color="primary" (click)="editForm()">
            <mat-icon>edit</mat-icon>  Edit
        </button> 
    </div>   
    <br>
    <div [ngClass]="{disabledDiv: !WriteAction}">
        <div class="row form-group" >
            <div class="col-sm-3">
                <mat-form-field style="display:flex;flex-direction: column;">
                    <mat-label>Institution ID</mat-label>
                    <input matInput placeholder="xx-xxx-xxxx" mask="00-000-0000" formControlName="institutionId" >
                </mat-form-field>
            </div>
            <div class="col-sm-3" [formGroup]="studentFormGroup">
                <mat-form-field style="display:flex;flex-direction: column;">
                    <mat-label>Workday ID</mat-label>
                    <input matInput placeholder="xxxxxxxx" mask="00000000" formControlName="workdayId" >
                </mat-form-field>
            </div>
            <div class="col-sm-2" [formGroup]="studentFormGroup">
                <mat-form-field style="display:flex;flex-direction: column;">
                    <mat-label>Slate ID</mat-label>
                    <input matInput placeholder="xx-xxx-xxxx" mask="00-000-0000" formControlName="slateId" >
                </mat-form-field>
            </div>
            <div class="col-sm-2" formGroupName="person">
                <mat-form-field style="display:flex;flex-direction: column;">
                    <mat-label>NCAA ID</mat-label>
                    <input matInput minlength="10" maxlength="10"  formControlName="ncaaid" >
                </mat-form-field>
            </div>
            <div class="col-sm-2" [formGroup]="studentFormGroup">
                <mat-form-field style="display:flex;flex-direction: column;">
                    <mat-label>Academic Record Reference Id</mat-label>
                    <input matInput formControlName="academicRecordReferenceId" >
                </mat-form-field>
            </div>
            <ng-container formGroupName="person">
                <div class="col-sm-3">
                    <mat-form-field style="display:flex;flex-direction: column;">
                        <mat-label>Last Name</mat-label>
                        <input matInput required placeholder="Last Name" maxlength="50" formControlName="lastName">
                    </mat-form-field>
                </div>
                <div class="col-sm-3">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>First Name</mat-label>
                        <input matInput required placeholder="First Name" maxlength="50" formControlName="firstName">
                    </mat-form-field>
                </div>
                <div class="col-sm-3">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Middle Name</mat-label>
                        <input matInput placeholder="Middle Name" maxlength="50" formControlName="middleName">
                    </mat-form-field>
                </div>
                <div class="col-sm-3">
                    <mat-form-field style="display:flex;flex-direction: column;">
                        <mat-label>Suffix</mat-label>
                        <input matInput  placeholder="Suffix" maxlength="6" formControlName="suffix">
                    </mat-form-field>
                </div>
                <div class="col-sm-3">
                    <mat-form-field style="display:flex;flex-direction: column;" dateFormat1>
                        <mat-label>Birth Date</mat-label>
                        <input matInput required formControlName="birthDate" [max]="currentDate" [min]="minDate" [matDatepicker]="picker1">
                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker touchUi #picker1></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-sm-3">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Sex</mat-label>
                        <mat-select required formControlName="sexId"[disabled]="student.isAddStudentByLsuId">
                            <mat-option>--Select--</mat-option>
                            <mat-option *ngFor="let item of sexList" [value]="item.id">
                                {{item.description}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <!-- <div class="col-sm-3">
                    <mat-form-field style="display:flex;flex-direction: column;">
                        <mat-label>NCAA ID</mat-label>
                        <input matInput minlength="10" maxlength="10" formControlName="ncaaid" >
                    </mat-form-field>
                </div> -->
                <div class="col-sm-3" hidden>
                    <mat-form-field style="display:flex;flex-direction: column;">
                        <mat-label>SSN</mat-label>
                        <input matInput maxlength="9" formControlName="ssn" >
                    </mat-form-field>
                </div>
                <div class="col-sm-3" hidden>
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Email</mat-label>
                        <input matInput email placeholder="Email" maxlength="250" formControlName="email">
                    </mat-form-field>
                </div>
            </ng-container>       
            <div class="col-sm-3">
                <mat-form-field style="display:flex;flex-direction: column">
                    <mat-label>Residence</mat-label>
                    <mat-select required formControlName="residenceId" >
                        <mat-option>--Select--</mat-option>
                        <ng-container *ngFor="let item of residenceList">
                            <mat-option *ngIf="evalBind(item,student.residenceId)" [value]="item.id">
                                {{item.description}}
                            </mat-option>
                      </ng-container> 
                    </mat-select>
                </mat-form-field>
            </div>            
            <div class="col-sm-3">
                <mat-checkbox formControlName="hasRecruitment" style="margin-top: 25px;">Recruited</mat-checkbox>
                &nbsp;
                <mat-checkbox formControlName="hasScholarship" style="margin-top: 25px;">Scholarship</mat-checkbox>
                &nbsp;
            <!-- </div>
            <div class="col-sm-3"> -->
                <mat-checkbox formControlName="hasImmunization" style="margin-top: 25px;">Immunization</mat-checkbox>
              </div>
        </div>
        <div class="row form-group">  
            <div class="col-sm-3">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Term First Enrolled At Any Institution</mat-label>
                        <mat-select formControlName="initialInstitutionTermId" (selectionChange)="onSelectFirstTermChange($event)" >
                            <mat-option>--Select--</mat-option>
                            <ng-container *ngFor="let item of institutionTermListFallSpringQuarter">
                                <mat-option *ngIf="evalBind(item,student.initialInstitutionTermId)" [value]="item.id">
                                    {{item.description}}
                                </mat-option>
                          </ng-container>
                        </mat-select>
                    </mat-form-field>
            </div>
            <div class="col-sm-3">
                <mat-form-field style="display:flex;flex-direction: column">
                    <mat-label>Term First Enrolled At This Institution</mat-label>
                    <mat-select required formControlName="initialTenantTermId" >
                        <mat-option>--Select--</mat-option>                      
                        <ng-container *ngFor="let item of institutionTermListFallSpring">
                            <mat-option *ngIf="evalBind(item,student.initialTenantTermId)" [value]="item.id">
                                {{item.description}}
                            </mat-option>
                      </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-sm-3">
                <mat-form-field style="display:flex;flex-direction: column">
                    <mat-label>Full Time Transfer Terms</mat-label>
                    <input matInput type="number" formControlName="fullTimeTransferTerms" step="1" min="0" ui-number-mask="3">
                </mat-form-field>
            </div>
        </div>      
        <div class="row form-group">
            <div class="col-sm-3">
                <mat-form-field style="display:flex;flex-direction: column">
                    <mat-label>Term Last Enrolled At This Institution</mat-label>
                    <mat-select formControlName="finalTenantTermId" >
                        <mat-option>--Select--</mat-option>                       
                        <ng-container *ngFor="let item of institutionTermList">
                            <mat-option *ngIf="evalBind(item,student.finalTenantTermId)" [value]="item.id">
                                {{item.description}}
                            </mat-option>
                      </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-sm-3">
                <mat-form-field style="display:flex;flex-direction: column">
                    <mat-label>Withdrawal Reason</mat-label>
                    <mat-select formControlName="withdrawalReasonId" >
                        <mat-option>--SELECT--</mat-option>
                        <ng-container *ngFor="let item of reasonsList">
                            <mat-option *ngIf="evalBind(item,student.withdrawalReasonId)" [value]="item.id">
                                {{item.description}}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>    
        <div class="row form-group">
            <div class="col-sm-3">
                <mat-form-field style="display:flex;flex-direction: column">
                    <mat-label>Declare Major Term</mat-label>
                    <mat-select formControlName="declaredMajorTermId" >
                        <mat-option>--Select--</mat-option>                        
                        <ng-container *ngFor="let item of institutionTermListFallSpring">
                            <mat-option *ngIf="evalBind(item,student.declaredMajorTermId)" [value]="item.id">
                                {{item.description}}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>       
            <div class="col-sm-3">
                <mat-form-field style="display:flex;flex-direction: column">
                    <mat-label>Declared Major</mat-label>
                    <mat-select formControlName="intendedMajorId" >
                        <mat-option>--Select--</mat-option>                      
                        <ng-container *ngFor="let item of majorDisciplineList">
                            <mat-option *ngIf="evalBind(item,student.intendedMajorId)" [value]="item.id">
                                {{item.description}}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-sm-3">
                <mat-form-field style="display:flex;flex-direction: column" dateFormat1>
                    <mat-label>Declared Major Date</mat-label>
                    <input matInput formControlName="intendedMajorDate" [max]="currentDate" [matDatepicker]="picker2">
                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                    <mat-datepicker touchUi #picker2></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-sm-3">
                <mat-form-field style="display:flex;flex-direction: column">
                    <mat-label>Term 9 Hour Waiver Used</mat-label>
                    <mat-select formControlName="nineHourWaiverTermId" >
                        <mat-option>--Select--</mat-option>                       
                        <ng-container *ngFor="let item of institutionTermListFall">
                            <mat-option *ngIf="evalBind(item,student.nineHourWaiverTermId)" [value]="item.id">
                                {{item.description}}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>        
            <div class="col-sm-3">
                <mat-form-field style="display:flex;flex-direction: column">
                    <mat-label>Term Exhausted Eligibility</mat-label>
                    <mat-select [disabled]="true">
                        <mat-option>--Select--</mat-option>
                        <mat-option *ngFor="let item of institutionTermList" [value]="item.id">
                            {{item.description}}
                        </mat-option>                        
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-sm-3">
                <mat-form-field style="display:flex;flex-direction: column;">
                    <mat-label>Classification</mat-label>
                    <input matInput [disabled]="true" placeholder="Classification" value="{{student.classification}}">
                </mat-form-field>
            </div>
            <!-- <div class="col-sm-3">
              <mat-checkbox [disabled]="true" formControlName="hasImmunization" style="margin-top: 2%;">Immunization</mat-checkbox>
            </div> -->
        </div>
    </div>   
    <div align="end" *ngIf="WriteAction">
        <button mat-raised-button color="primary" [disabled]="!studentFormGroup.valid" (click)="onSubmit()">
            <mat-icon>save</mat-icon>  {{this.student && this.student.studentId !== null ? 'Update': 'Save'}}
        </button>
        &nbsp;
        <button mat-raised-button (click)="cancel()">
            Cancel
        </button>
    </div>
</div>
